import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { store } from '../../redux/store';
import { alpha,styled, Avatar, Link } from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import InputBase from '@mui/material/InputBase';

interface HeaderProps {
  title: string;
  queryCallback:any;
  sections: ReadonlyArray<{
    title: string;
    url: string;
  }>;
}
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));


export default function Header(props: HeaderProps) {
  const { title,queryCallback,sections } = props;
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Toolbar sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Typography
          component="h2"
          variant="h4"
          color="inherit"
          align="center"
          noWrap
          sx={{ flex: 1 }}
        >
          {title}
        </Typography>
        <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="搜索..."
              onChange={(event)=>{queryCallback(event.currentTarget.value)}}
              inputProps={{ 'aria-label': 'search' }}
            />
        </Search>
        {
          !store.getState().account.token?
          <Button variant="outlined" size="small" onClick={()=>{navigate("/signin",{state:{redirect:"/"}})}}>注册/登录</Button>
          :
          <IconButton onClick={()=>{navigate("/console")}}>
            <Avatar sx={{ bgcolor: deepOrange[500] }}>{store.getState().account.nickname.substring(0,1)}</Avatar>
          </IconButton>
        }
      </Toolbar>
      <Toolbar
        component="nav"
        variant="dense"
        sx={{ justifyContent: 'right', overflowX: 'auto' }}
      >
        {sections.map((section) => (
          <Link
            color="inherit"
            noWrap
            key={section.title}
            variant="body2"
            href={section.url}
            sx={{ p: 1, flexShrink: 0,textDecoration:"none" }}
          >
            {section.title}
          </Link>
        ))}
        
      </Toolbar>
    </React.Fragment>
  );
}
